const GoVue = {};

GoVue.methods = {};
GoVue.computed = {};
GoVue.watch = {};
GoVue.components = {};

export default { vue: GoVue };
